module.exports = __webpack_public_path__ + "static/img/QA@3x.2de4e9f3.jpg";